import { FormControl, ValidationErrors } from '@angular/forms';

//Allow only letters, might be uppercase or lowercase
//At least 3 characters for firstName
//An space to indicate the lastName
//Then at least 1 character for lastName
const FULL_NAME_REGEX = /^[a-zA-ZÀ-ú1-9]{3,} [a-zA-ZÀ-ú1-9]{1,}/;
const FULL_NAME_VALIDATION_ERROR = { alphaNumericError: 'should be provided a name and a last name' };

export function fullNameValidator(control: FormControl): ValidationErrors | null {
    return FULL_NAME_REGEX.test(control.value) ? undefined : FULL_NAME_VALIDATION_ERROR;
}